import React, {useState, useRef, useEffect} from "react";
import {withRouter} from "react-router-dom";
import {useActivate, useUnactivate} from "react-activation";
import {NavBar} from "antd-mobile";
import ChuangShiOS from "chuangshi-os-mobile-component";

import Application from "../../common/Application";

import Style from "./Detail.module.css";

const ShopDetail = (props) => {
    const request = useRef(false);
    const [isLaunch, setIsLaunch] = useState(false);
    const [trade, setTrade] = useState({});

    useEffect(() => {
        handleLoadTrade();

        //eslint-disable-next-line
    }, []);

    useActivate(() => {});

    useUnactivate(() => {});

    const handleLoadTrade = () => {
        if (request.current) {
            return;
        }
        request.current = true;

        if (isLaunch) {
            ChuangShiOS.Util.toastLoad();
        }

        ChuangShiOS.Util.request(props, {
            url: Application.host + "/windeal/trade/consumer/mobile/v1/find",
            data: {
                tradeId: props.match.params.tradeId,
            },
            success: (response) => {
                if (isLaunch) {
                    ChuangShiOS.Util.toastHide();
                }

                setTrade(response.data);
            },
            error: (response) => {
                ChuangShiOS.Util.toastError({
                    message: response.message,
                    complete: () => {},
                });
            },
            complete: (response) => {
                request.current = false;

                setIsLaunch(true);
            },
        });
    };

    return (
        <ChuangShiOS.Page>
            <NavBar
                back="返回"
                style={{
                    "--border-bottom": "1px #eee solid",
                }}
                onBack={() => {
                    ChuangShiOS.Util.navigateBack(props);
                }}
            >
                {trade.tradeStatusValue}
            </NavBar>
            <ChuangShiOS.Content isLaunch={isLaunch} isEmpty={false}>
                <div className={Style.empty}></div>
            </ChuangShiOS.Content>
        </ChuangShiOS.Page>
    );
};

ShopDetail.propTypes = {};

ShopDetail.defaultProps = {};

export default withRouter(ShopDetail);
